import React from 'react';

import pagerduty from 'src/lib/api/pagerduty';
import { getQueryParams } from 'src/lib/history';

import GenericAsyncSelect from 'src/views/components/select/GenericAsyncSelect';

const findLevels = async () => {
  const { incidentId } = getQueryParams();
  const { escalation_policy: { id } = {} } = await pagerduty.getIncident(incidentId);
  if (!id) return [];

  const { escalation_rules } = await pagerduty.getEscalationPolicy(id);

  if (!escalation_rules || escalation_rules.length === 0) return [];
  return escalation_rules.map(({ targets = [] } = {}, index) => ({
    label: `${targets.map(t => t.summary).join(', ')} (level ${index + 1})`,
    index: `${index + 1}`,
    id: `${index + 1}`,
  }));
};

const PdEscalationLevelSelect = ({ ...props }) => {
  return (
    <GenericAsyncSelect
      options={findLevels}
      {...props}
    />
  );
};

export default PdEscalationLevelSelect;
